<template>
  <div class="no-data">
    <img :src="require('@/assets/no-results.svg')"/>
    No data available
  </div>
</template>

<script>
export default {
  name: 'NoResult',
  props: {
    
  }
}
</script>

<style lang="stylus">
    .no-data {
      width 140px
      height 140px
      text-align center
    }
</style>
